import { colors, LayoutBand, Separator, Skeleton, useContainerWidth } from '@fs/zion-ui'
import React from 'react'
import PersonStickyHeaderSkeleton from './PersonStickyHeaderSkeleton'

export default function ContributionsHeaderSkeleton(): JSX.Element {
  const isSmallScreen = useContainerWidth()({ default: true, lg: false })

  return (
    <>
      {!isSmallScreen && (
        <LayoutBand maxWidth="xxl" color={colors.gray00}>
          <Separator size="nano" />
          <Skeleton.Button data-testid="header-skeleton-button" minWidth={200} />
        </LayoutBand>
      )}
      <PersonStickyHeaderSkeleton />
    </>
  )
}
